module.exports = __webpack_public_path__ + "images/d161cde691896d94a10fd6ef7ad28e10-logo.png";